const base = 'transactions/';

const AssignApi = {
  base,
  assign: base + 'assign',
  verify: base + 'verify'
};

export default AssignApi;
